import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Application } from '../../../../shared/types';
import { useAdminApplications } from '../../../hooks/useAdminApplications';
import { ApplicationForm } from './ApplicationForm';

export const ApplicationEdit = () => {
    const { id } = useParams<{ id: string }>();
    const [selectedApplication, setSelectedApplication] = useState<Application>();
    const { data: applications = [], isFetched } = useAdminApplications();

    useEffect(() => {
        if (!isFetched) return;

        const application = applications.find((application) => application._id.toString() === id!);

        if (application) setSelectedApplication(application);
    }, [id, isFetched]);

    if (!selectedApplication) return null;

    return <ApplicationForm application={selectedApplication} />;
};
